<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.symbollibrary") }}</h4>
    </div>
    <div class="commTop_btn_wrap" style="text-align: right">
      <div class="btn_wrap fR p-2">
        <button type="button" @click="addSymbol" class="btn btn-primary btn-md m-1">
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="saveSymbol" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
        <button type="button" @click="deleteSymbol" class="btn btn-secondary btn-md m-1">
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>
    <div class="sub_contents_wrap">
      <div class="symbol_scroll" style="overflow: auto; height: 700px">
        <table class="tbl_public">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  v-model="checkAll"
                  @click="goCheckAll($event.target.checked)"
                />
              </th>
              <th>Symbol</th>
              <th>{{ $t("management.number") }}</th>
              <th>{{ $t("management.type") }}</th>
              <th>{{ $t("management.meaning") }}</th>
            </tr>
          </thead>
          <draggable v-model="symbolList" tag="tbody">
            <tr v-for="(sym, index) in symbolList" :key="index">
              <td :id="sym.id"><input type="checkbox" v-model="sym.selected" /></td>
              <td class="w-25">
                <div class="d-flex">
                  <img :src="'/symbollibrary/img/' + sym.imgFileNo" class="syb_img" />
                  <input
                    type="button"
                    @click="fileSelect(index, sym.imgFileNo)"
                    :id="'img' + sym.id"
                    class="img_box"
                    :ref="'img' + index"
                    value="image"
                  />
                </div>
              </td>
              <td class="w-25">{{ sym.sort }}</td>
              <td class="w-25">
                <input type="text" v-model="sym.type" class="int_type01" />
              </td>
              <td class="w-25">
                <input
                  type="text"
                  v-model="sym.meaning"
                  class="int_type01"
                  name="meaning"
                  v-validate="'required'"
                />
              </td>
            </tr>
          </draggable>
        </table>
      </div>
    </div>
    <!--새로운 symbol 추가-->
    <CommonModal id="symNewModal" v-if="showNewModal" @close="showNewModal == false">
      <template slot="header">
        <h3>{{ $t("management.addSymbol") }}</h3>
      </template>
      <template slot="body">
        <table class="tbl_public">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>{{ $t("management.type") }}</th>
              <th>{{ $t("management.meaning") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="w-25">
                <div class="d-flex">
                  <img :src="fileUrl" class="syb_img" />
                  <input
                    type="file"
                    id="file"
                    accept="image/png,image/jpeg,image/,image/bmp"
                    @change="uploadNewSymbolImg($event)"
                    style="display: none"
                  />
                  <div class="upload_area" style="margin-left: 10px; margin-top: 2px">
                    <a href="#" class="upload_bt" @click="AC_fileClick">Upload</a>
                  </div>
                </div>
              </td>
              <td class="w-25">
                <input type="text" v-model="symbol.type" class="int_type01" />
              </td>
              <td class="w-25">
                <input
                  type="text"
                  v-model="symbol.meaning"
                  class="int_type01"
                  name="meaning"
                  v-validate="'required'"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="saveNewSymbol"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
    <!--이미지 추가 및 변경 모달-->
    <CommonModal id="symModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.addImage") }}</h3>
      </template>
      <template slot="body">
        <div class="d-flex">
          <div class="m-2">
            <img :src="fileUrl" class="syb_img" />
          </div>
          <div class="m-2">
            <input
              type="file"
              id="file"
              accept="image/png,image/jpeg,image/jpg,image/bmp"
              @change="upload('img' + index, $event)"
              style="display: none"
              :ref="'img' + index"
            />
            <div class="upload_area">
              <a href="#" class="upload_bt" @click="AC_fileClick">Upload</a>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="saveSymbol"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>
<script>
import $ from "jquery";
import draggable from "vuedraggable";
import { getSymbolLibraryList, updateSymbolLibrary } from "@/api/symbollibrary";
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    draggable,
    CommonModal,
  },
  data() {
    return {
      symbolList: [],
      id: "",
      status: "",
      symbol: {
        id: "",
        fileUrl: "",
        selected: false,
        type: "",
        meaning: "",
        crudType: "I",
      },
      checkAll: false,
      addList: 0,
      fileUrl: "/",
      index: "",
      showModal: false,
      showNewModal: false,
      acceptFileType: ["jpg", "png", "jpeg", "bmp"],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getSymbolLibraryList();
        this.symbolList = data.symbolList;
      } catch (error) {
        console.log(error);
      }
    },
    fileSelect(index, fileNo) {
      this.fileUrl = "/";
      this.index = index;
      if (fileNo != null) {
        this.fileUrl = "/symbollibrary/img/" + fileNo;
      }
      this.showModal = true;
    },
    AC_fileClick() {
      $("#file").click();
    },
    // 기존 심볼 이미지 추가/변경
    upload(ref, event) {
      let input = event.target;
      let tmp = input.files[0].name;
      let fileName = tmp.split(".");
      let accept = false;
      for (let i in this.acceptFileType) {
        if (fileName[fileName.length - 1] == this.acceptFileType[i]) {
          accept = true;
          break;
        }
      }
      if (!accept) {
        alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        return;
      }
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.symbolList[this.index].fileUrl = e.target.result;
          this.fileUrl = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
      this.symbolList[this.index].crudType = "U";
      this.symbolList[this.index].realFile = input.files[0];
    },
    // 새로운 심볼 이미지 추가
    uploadNewSymbolImg(event) {
      let input = event.target;
      let tmp = input.files[0].name;
      let fileName = tmp.split(".");
      let accept = false;
      for (let i in this.acceptFileType) {
        if (fileName[fileName.length - 1] == this.acceptFileType[i]) {
          accept = true;
          break;
        }
      }
      if (!accept) {
        alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        return;
      }
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.symbol.fileUrl = e.target.result;
          this.fileUrl = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
      this.symbol.crudType = "I";
      this.symbol.realFile = input.files[0];
    },
    closeModal() {
      this.showModal = false;
      this.showNewModal = false;
      this.symbol = {};
    },
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.symbolList) {
        this.symbolList[i].selected = this.checkAll;
      }
    },
    // 새로운 symbol 추가
    addSymbol() {
      this.showNewModal = true;
    },
    async saveSymbol() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (!confirm(this.$t("alert.save"))) return;
      const formData = new FormData();
      for (let i in this.symbolList) {
        if (this.symbolList[i].id != null) {
          formData.append("symbolList[" + i + "].id", this.symbolList[i].id);
        }
        formData.append("symbolList[" + i + "].type", this.symbolList[i].type);
        formData.append("symbolList[" + i + "].meaning", this.symbolList[i].meaning);
        if (this.symbolList[i].sort != null) {
          formData.append("symbolList[" + i + "].sort", this.symbolList[i].sort);
        }
        if (this.symbolList[i].imgFileNo != null) {
          formData.append(
            "symbolList[" + i + "].imgFileNo",
            this.symbolList[i].imgFileNo
          );
        }
        if (this.symbolList[i].fileUrl != null) {
          formData.append("symbolList[" + i + "].fileUrl", this.symbolList[i].fileUrl);
        }
        if (this.symbolList[i].realFile != null) {
          formData.append("symbolList[" + i + "].realFile", this.symbolList[i].realFile);
        }
        formData.append("symbolList[" + i + "].crudType", this.symbolList[i].crudType);
      }
      const { data } = await updateSymbolLibrary(formData);
      if (data.status) {
        alert(this.$t("alert.changedSuccessfully"));
        this.addList = 0;
        this.fileUrl = "";
        this.symbol = {};
        this.showNewModal = false;
        this.showModal = false;
        this.fetchData();
      } else {
        alert(this.$t("alert.ErrorPlzcontactManager"));
      }
    },
    async saveNewSymbol() {
      this.symbol.crudType = "I";
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      this.symbolList.push(this.symbol);
      this.saveSymbol();
    },
    deleteSymbol() {
      for (let i in this.symbolList) {
        if (this.symbolList[i].selected) {
          if (this.symbolList[i].id == "") {
            this.$delete(this.symbolList, i);
          } else {
            this.symbolList[i].crudType = "D";
            $("#" + this.symbolList[i].id)
              .closest("tr")
              .remove();
            alert(this.$t("alert.deletedSuccessfullyButYouNeedToClickTheSaveButton"));
          }
        }
      }
    },
  },
};
</script>

<style scoped>
tbody tr td input[type="file"] {
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.syb_img {
  margin: 0 0 0 40px;
  height: 40px;
  width: 40px;
}
</style>
